<template lang="html">
  <div id="NavBar" :class="[['Main', 'Login', 'MyProject'].indexOf(this.$router.history.current.name) !== -1 ? '' : 'back-white gm-shadow']">
    <div class="logo slideRight">
      <router-link to="/">
        <img src="@/assets/logo/logo_transparent.png" v-if="['Main', 'Login', 'MyProject'].indexOf(this.$router.history.current.name) !== -1">
        <img src="@/assets/logo/logo_white.png" v-else>
      </router-link>
    </div>
    <!-- Title -->
    <!-- <div class="title">{{ getState.title }}</div> -->
    <!-- Project : Filter -->
    <el-popover placement="bottom" width="50" height="200" trigger="click" v-if="this.$route.name === 'Project' && teamsNum > 1" v-model="showFilter" style="margin-top: 5px;">
      <div class="gm-layout-vertical" style="overflow-y: auto; max-height: 160px;">
        <el-button @click="selectTeam(-1)" style="border: none; margin: 0px; min-height: 35px;" :disabled="selectedTeamIndex === -1">전체</el-button>
        <el-button @click="selectTeam(teamIndex - 1)" style="border: none; margin: 0px; min-height: 35px;" :disabled="selectedTeamIndex === teamIndex - 1" v-for="teamIndex in teamsNum" :key="teamIndex">{{ teamIndex }}팀</el-button>
      </div>
      <div slot="reference">
        <el-button style="border: none; margin: 0px;">
          {{ (selectedTeamIndex === -1)? '전체' : `${selectedTeamIndex + 1}팀` }}
          <i class="el-icon-caret-bottom el-icon-right" />
        </el-button>
      </div>
    </el-popover>
    <!-- Login -->
    <div class="login slideLeft">
      <div v-if="!getState.isLogin">
        <span id="login-button" :class="[['Main', 'Login', 'MyProject'].indexOf(this.$router.history.current.name) !== -1 ? 'login-button white' : 'login-button black']" @click="login">Login</span>
      </div>
      <el-popover placement="bottom" width="200" trigger="click" v-model="popupVisibility" v-else>
        <!-- Profile -->
        <div id="NavBarPopover" class="gm-layout-vertical">
          <div class="gm-layout-horizontal gm-align-vertical-center">
            <div class="cropper">
              <img class="img-profile" src="@/assets/gif/profile.gif" alt="default profile">
            </div>
            <div class="gm-layout-vertical">
              <p style="margin-left: 18px; font-size: large">{{ getState.user.properties.nickname }}</p>
              <p style="margin-left: 18px; font-size: small">#{{ getState.user.id }}</p>
            </div>
          </div>
          <hr style="margin: 12px 4px;" />
          <!-- My projects -->
          <div class="gm-layout-horizontal gm-align-vertical-center">
            <img src="@/assets/icon/apps.svg" alt="logout" style="width: 24px; height: 24px; padding-left: 6px; margin-right: 2px;">
            <el-button class="gm-width-match-parent" @click="myProjects()" style="font-size: medium; border: none;">내 프로젝트
            </el-button>
          </div>
          <!-- Logout -->
          <div class="gm-layout-horizontal gm-align-vertical-center">
            <img src="@/assets/icon/logout.svg" alt="logout" style="width: 24px; height: 24px; margin-right: 2px;">
            <el-button class="gm-width-match-parent" @click="logout()" style="font-size: medium; border: none;">로그아웃
            </el-button>
          </div>
        </div>
        <!-- Popup trigger button -->
        <button id="NavBarButton" slot="reference">
          <img class="img-profile" src="@/assets/gif/profile.gif" alt="default profile">
        </button>
      </el-popover>
    </div>
  </div>
</template>
<script>
import { auth } from '@/firebase'
export default {
  name: 'NavBar',
  components: {},
  data: () => ({
    popupVisibility: false,
    teamsNum: null,
    selectedTeamIndex: -1,
    showFilter: false
  }),
  mounted() {
    // Emmit from project subscribeProjectInfo() in method
    this.$event.$on(this.$eventList.teamsNum, teamsNum => {
      this.teamsNum = Number(teamsNum)
    })
  },
  beforeDestroy() {
    this.$event.$off([
      this.$eventList.teamsNum
    ])
  },
  methods: {
    login() {
      this.$router.push({
        path: '/login',
        query: { redirect: this.$router.history.current.fullPath }
      })
    },
    logout() {
      this.popupVisibility = false
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '로그아웃',
        acceptText: '네. 로그아웃 할래요.',
        cancelText: '아니요. 좀 더 머무를래요.',
        text: '로그아웃 하시겠습니까? 🙊',
        accept: _ => {
          auth.signOut().then(() => {
            this.$log.d('Success to firebase logout')
            Kakao.Auth.logout(() => {
              this.$log.d('Success to kakao logout')
              this.$store.dispatch('logout')
              this.$router.push('/')
            })
          }).catch(err => {
            this.$log.w('Fail to firebase logout', err)
          })
        }
      })
    },
    myProjects() {
      this.popupVisibility = false
      this.$router.push('/projects/' + this.getState.user.id)
    },
    selectTeam(teamIndex) {
      this.selectedTeamIndex = teamIndex
      this.$event.$emit(this.$eventList.selectedTeamIndex, this.selectedTeamIndex)
      this.showFilter = false
    }
  },
  computed: {
    getState() {
      return this.$store.state
    }
  }
}

</script>
<style lang="scss" scoped>
#NavBar {
  display: flex;
  align-items: center;
  padding: 6px 16px;
  height: 52px;
  z-index: 2000;
  /* Spread alignment */
  justify-content: space-between;

  .logo,
  .title,
  .login {
    /* Fix size */
    flex: none;
    /* Align center */
    margin-top: auto;
    margin-bottom: auto;
  }

  .logo img {
    height: 40px;
  }

  .login-button {
    cursor: pointer;
    font-size: 1.3rem;
    padding-right: 0px;
  }

  .back-white {
    background-color: white;
  }

  .white {
    color: white;
  }

  .black {
    color: black;
  }

  .title {
    font-size: 13px;
    flex: 0 1 auto;
    margin-left: 32px;
    margin-right: 32px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

#NavBarPopover {
  .cropper {
    width: 40px;
    height: 40px;
    position: relative;
    border: none;
    overflow: hidden;
    border-radius: 50%;
  }

  .large-unkown {
    font-size: 58px;
  }
}

#NavBarButton {
  width: 40px;
  height: 40px;
  position: relative;
  border: none;
  overflow: hidden;
  border-radius: 50%;

  .small-unkown {
    font-size: 28px;
  }
}

#NavBarPopover,
#NavBarButton {
  .img-profile {
    display: inline;
    margin: 0 auto;
    height: 40px;
    width: auto;
  }
}

/* Mobile */
@media only screen and (max-width : 768px) {
  #NavBar {
    padding: 4px 8px;

    .login-button {
      font-size: 1.4rem;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/NavBar/index.vue